// Copyright (c) 2016 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';

const AmountOfUseHistoryPanelListHeader = () =>
    <section className='amount-of-use-history-list-header'>
        <span className='date'>
            <FormattedMessage id='DATE'/>
        </span>
        <span className='description'>
            <FormattedMessage id='DESCRIPTION'/>
        </span>
        <span className='amount-recorded'>
            <FormattedMessage id='AMOUNT_RECORDED'/>
        </span>
        <span className='unit'>
            <FormattedMessage id='UNIT'/>
        </span>
    </section>;

AmountOfUseHistoryPanelListHeader.displayName = 'AmountOfUseHistoryPanelListHeader';

export default AmountOfUseHistoryPanelListHeader;



// WEBPACK FOOTER //
// ./src/product/details/components/amount-of-use-history-panel/amount-of-use-history-panel-list-header.js